module.exports = __webpack_public_path__ + "img/Security4_JP@3x.6b592c4e.png";